module.exports = __webpack_public_path__ + "media/images/patent/y_1-365ca3d0fbc8d7d85bbe08a67d0eaca1.jpg";